import { render, staticRenderFns } from "./CbxTaxTreatment.vue?vue&type=template&id=51980aa1&"
import script from "./CbxTaxTreatment.vue?vue&type=script&lang=ts&"
export * from "./CbxTaxTreatment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports